/**
 * Route constants for the application
 * This file centralizes all route paths to make them easier to maintain
 */

export const ADVISOR_ROUTES = {
    LOGIN: '/login',
    ROOT: '/',
    ACCESS_DENIED: '/accessdenied',

    ADMIN: '/admin',
    ADD_USER: '/add-user',
    ADVISOR_CONSOLE: '/advisorconsole',
    DASHBOARD: '/dashboard',
    CLIENT_PROFILE: '/clientprofile',
    RISK_TOLERANCE: '/risktolerance',
    GOALS: '/goals',
    FUNDING_NAVIGATOR: '/fundingnavigator',
    PLAN_DETAILS: '/plandetails',
    RESOURCES: '/resources',
    RECENT_UPDATES: '/recentupdates',
    USER: '/user',
    PLAN_EXECUTION: '/planexecution',
    NOT_FOUND: '*'
};
